module.exports = __webpack_public_path__ + "img/sorcero-white.66f65b45.png";